/** Front-end routes **/

export const prefixSelectFidelity = "listagem-programa-de-fidelidade";
export const prefixFidelityAndBank = "login-programa-de-fidelidade";
export const prefixOfferMiles = "oferta-de-milhas";
export const prefixCreditCard = "cartao-de-credito";
export const prefixValidateOffer = "validacao-oferta";
export const prefixFinished = "milhas-cadastradas";
export const prefixFinishedError = "erro-oferta";

export const ROUTE_PREFIX = `/cliente`;
export const ROUTE_PREFIX_CREATE_OFFER = `/ofertantes`;
export const ROUTE_PREFIX_EDIT_OFFER = `/ofertantes/editar`;
export const ROUTE_PREFIX_CREATE_OFFER_MOBILE = `/m${ROUTE_PREFIX_CREATE_OFFER}`;
export const ROUTE_PREFIX_EDIT_OFFER_MOBILE = `/m${ROUTE_PREFIX_EDIT_OFFER}`;
export const ROUTE_HOME = `${ROUTE_PREFIX}/minhas-ofertas`;
export const ROUTE_HOME_OFFER = `${ROUTE_HOME}/oferta`;
export const ROUTE_HOME_SHARED = `${ROUTE_HOME}/shared`;
export const ROUTE_SALE = `${ROUTE_PREFIX}/minhas-vendas`;
export const ROUTE_RANKING = `${ROUTE_PREFIX}/ranking`;
export const ROUTE_ACCOUNT_DETAILS = `${ROUTE_PREFIX}/editar/dados-bancarios`;
export const ROUTE_MY_PASSENGERS = `/cliente/vendas-por-passageiro`;
export const ROUTE_SALE_DETAILS = `${ROUTE_PREFIX}/detalhes-venda`;
export const ROUTE_CREATE_OFFER = `/ofertantes/${prefixSelectFidelity}`;
export const ROUTE_CREATE_OFFER_MOBILE = `/m${ROUTE_CREATE_OFFER}`;
export const ROUTE_REDIRECT_OFFER = `${ROUTE_PREFIX}/redirecionamento/oferta`;
export const ROUTE_SMART_EXTRACT = `${ROUTE_PREFIX}/extrato-inteligente`;
export const ROUTE_ADVANCED_MANAGEMENT = `${ROUTE_PREFIX}/gestao-avancada`;
export const ROUTE_CREATE_OFFER_SIMULATOR = `${ROUTE_CREATE_OFFER}/simulador-milhas`;
export const ROUTE_CREATE_OFFER_LOGIN = `${ROUTE_CREATE_OFFER}/login-cia`;
export const ROUTE_CREATE_OFFER_BANK_DETAILS = `${ROUTE_CREATE_OFFER}/dados-bancarios`;
export const ROUTE_CREATE_OFFER_CREDIT_CARD = `${ROUTE_CREATE_OFFER}/cartao-credito`;
export const ROUTE_CREATE_OFFER_FINISHED = `${ROUTE_CREATE_OFFER}/parabens`;
export const ROUTE_SALE_MILES = `/vender-milhas`;
export const ROUTE_LANDING_PAGE = `/quero-vender-milhas`;
export const ROUTE_IFRAME_OFFER = `/iframe/simulador-oferta`;
export const ROUTE_REDIRECT_SIMULATOR = `/redirecionamento/simulador`;
export const ROUTE_IFRAME_AMP_OFFER = `/amp-iframe/simulador-oferta`;

// Advanced Management
export const ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_STARTED =
	"ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_STARTED";
export const ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_FINISHED =
	"ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_FINISHED";
export const ADVANCED_MANAGEMENT_IS_MANAGER_STARTED = "ADVANCED_MANAGEMENT_IS_MANAGER_STARTED";
export const ADVANCED_MANAGEMENT_IS_MANAGER_FINISHED = "ADVANCED_MANAGEMENT_IS_MANAGER_FINISHED";
export const ADVANCED_MANAGEMENT_SET_STEP = "ADVANCED_MANAGEMENT_SET_STEP";
export const ADVANCED_MANAGEMENT_STORE_DATA = "ADVANCED_MANAGEMENT_STORE_DATA";
export const ADVANCED_MANAGEMENT_STORE_DATA_DOCUMENTS = "ADVANCED_MANAGEMENT_STORE_DATA_DOCUMENTS";
export const ADVANCED_MANAGEMENT_SEND_DOCUMENTS_STARTED =
	"ADVANCED_MANAGEMENT_SEND_DOCUMENTS_STARTED";
export const ADVANCED_MANAGEMENT_SEND_DOCUMENTS_FINISHED =
	"ADVANCED_MANAGEMENT_SEND_DOCUMENTS_FINISHED";
export const ADVANCED_MANAGEMENT_SEARCH_BY_CPF_STARTED =
	"ADVANCED_MANAGEMENT_SEARCH_BY_CPF_STARTED";
export const ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_CLEAN =
	"ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_CLEAN";
export const ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED =
	"ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED";
export const ADVANCED_MANAGEMENT_IF_RENDER_MODAL_INVALID_CPF =
	"ADVANCED_MANAGEMENT_IF_RENDER_MODAL_INVALID_CPF";
export const ADVANCED_MANAGEMENT_STATUS_FILTERED = "ADVANCED_MANAGEMENT_STATUS_FILTERED";
export const ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_STARTED =
	"ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_STARTED";
export const ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_FINISHED =
	"ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_FINISHED";
export const ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_STARTED =
	"ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_STARTED";
export const ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_FINISHED =
	"ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_FINISHED";
export const ADVANCED_MANAGEMENT_CLEAN_ERROR_CANCEL_RELATIONSHIP =
	"ADVANCED_MANAGEMENT_CLEAN_ERROR_CANCEL_RELATIONSHIP";
export const ADVANCED_MANAGEMENT_SENDING_FILE = "ADVANCED_MANAGEMENT_SENDING_FILE";

// Account Link
export const ACCOUNT_LINK_GET_RELATIONSHIP_STARTED = "ACCOUNT_LINK_GET_RELATIONSHIP_STARTED";
export const ACCOUNT_LINK_GET_RELATIONSHIP_FINISHED = "ACCOUNT_LINK_GET_RELATIONSHIP_FINISHED";
export const ACCOUNT_LINK_SET_STEP = "ACCOUNT_LINK_SET_STEP";
export const ACCOUNT_LINK_STORE_DATA = "ACCOUNT_LINK_STORE_DATA";
export const ACCOUNT_LINK_GET_MANAGER_BY_CPF_STARTED = "ACCOUNT_LINK_GET_MANAGER_BY_CPF_STARTED";
export const ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED = "ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED";
export const ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_STARTED =
	"ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_STARTED";
export const ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_FINISHED =
	"ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_FINISHED";
export const ACCOUNT_LINK_PARTICIPANT_SENDING_FILE = "ACCOUNT_LINK_PARTICIPANT_SENDING_FILE";
export const ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_STARTED =
	"ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_STARTED";
export const ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_FINISHED =
	"ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_FINISHED";
export const ACCOUNT_LINK_SEARCH_MANAGER_BY_CPF_CLEAN = "ACCOUNT_LINK_SEARCH_MANAGER_BY_CPF_CLEAN";
export const ACCOUNT_LINK_IF_RENDER_MODAL_INVALID_CPF = "ACCOUNT_LINK_IF_RENDER_MODAL_INVALID_CPF";
// export const ACCOUNT_LINK_SET_FILE_PARTICIPANT =
// 	"ACCOUNT_LINK_SET_FILE_PARTICIPANT";

// Offers
export const OFFERS_RECEIVED = "OFFERS_RECEIVED";
export const IS_RELOAD_OFFERS = "IS_RELOAD_OFFERS";
export const EDIT_OFFER = "EDIT_OFFER";
export const VIEW_OFFER = "VIEW_OFFER";
export const VIEW_RANKING = "VIEW_RANKING";
export const IS_NEW_USER = "IS_NEW_USER";
export const SHOW_OFFERS = "SHOW_OFFERS";
export const RECEIVE_OFFERS_LOCALE = "RECEIVE_OFFERS_LOCALE";
export const SEARCHING_OFFERS = "SEARCHING_OFFERS";
export const RECEIVE_OFFER_RANK = "RECEIVE_OFFER_RANK";
export const SENDING_OFFER = "SENDING_OFFER";
export const QUICK_SALE_CLEAN = "QUICK_SALE_CLEAN";

// Create offer
export const SAVE_FORM_OFFER_VALUES = "SAVE_FORM_OFFER_VALUES";
export const BANKS_RECEIVED = "BANKS_RECEIVED";
export const TYPE_PHONE_REQUIRED = "TYPE_PHONE_REQUIRED";

// Market analysis
export const MARKET_ANALYSIS_RECEIVED = "MARKET_ANALYSIS_RECEIVED";

// Summary payment
export const SUMMARY_PAYMENT_RECEIVED = "SUMMARY_PAYMENT_RECEIVED";

// SalesPassengers
export const GET_SALES_PASSENGERS = "GET_SALES_PASSENGERS";
export const GET_SALES_PASSENGERS_SUCCESS = "GET_SALES_PASSENGERS_SUCCESS";
export const GET_SALES_PASSENGERS_ERROR = "GET_SALES_PASSENGERS_ERROR";
export const GET_SALES_PASSENGERS_NOT_FOUND = "GET_SALES_PASSENGERS_NOT_FOUND";
export const GET_PROGRAMS = "GET_PROGRAMS";
export const GET_PROGRAMS_SUCCESS = "GET_PROGRAMS_SUCCESS";
export const GET_PROGRAMS_ERROR = "GET_PROGRAMS_ERROR";
export const MY_PASSENGERS_FILTERED = "MY_PASSENGERS_FILTERED";

// Sales
export const SALES_RECEIVED = "SALES_RECEIVED";
export const EXPORT_FINISHED = "EXPORT_FINISHED";
export const EXPORT_DOCS_FINISHED = "EXPORT_DOCS_FINISHED";
export const DATA_WAS_REQUESTED = "DATA_WAS_REQUESTED";
export const EXPORT_WAS_REQUESTED = "EXPORT_WAS_REQUESTED";
export const SALES_FILTER_HAS_ERRORS = "SALES_FILTER_HAS_ERRORS";
export const SALES_TAB_STATUS_FILTERED = "SALES_TAB_STATUS_FILTERED";
export const SALES_FILTERED = "SALES_FILTERED";
export const SALES_VIEW_MODE = "SALES_VIEW_MODE";
export const SALES_OPEN_CLOSE_FILTER_MODAL = "SALES_OPEN_CLOSE_FILTER_MODAL";
export const SALES_OPEN_CLOSE_EXPORT_MODAL = "SALES_OPEN_CLOSE_EXPORT_MODAL";
export const EXPORT_FINISHED_MODAL = "EXPORT_FINISHED_MODAL";
export const SALES_FIND_ERROR = "SALES_FIND_ERROR";
export const SALES_HAS_FIELD_ERRORS = "SALES_HAS_FIELD_ERRORS";
export const SALES_SEARCH_NOT_FOUND = "SALES_SEARCH_NOT_FOUND";
export const SALES_OPEN_CLOSE_SEARCH_MOBILE = "SALES_OPEN_CLOSE_SEARCH_MOBILE";
export const SALES_SEARCH_IS_OPEN = "SALES_SEARCH_IS_OPEN";
export const SALES_SEARCH_RECEIVED = "SALES_SEARCH_RECEIVED";
export const DATA_SEARCH_WAS_REQUESTED = "DATA_SEARCH_WAS_REQUESTED";
export const EXPORT_IRPF_REQUESTED = "EXPORT_IRPF_REQUESTED";
export const EXPORT_IRPF_FINISH = "EXPORT_IRPF_FINISH";
export const OPEN_CLOSE_GENERAL_ALERT = "OPEN_CLOSE_GENERAL_ALERT";

// Others
export const FIDELITY_PLANS_RECEIVED = "FIDELITY_PLANS_RECEIVED";
export const FIDELITY_PLANS_FROM_USER_SALES_RECEIVED = "FIDELITY_PLANS_FROM_USER_SALES_RECEIVED";
export const FIDELITY_PLANS_FROM_USER_SALES_EMPTY = "FIDELITY_PLANS_FROM_USER_SALES_EMPTY";
export const PAYMENTS_DATA_WAS_REQUESTED = "PAYMENTS_DATA_WAS_REQUESTED";
export const PAYMENTS_RECEIVED = "PAYMENTS_RECEIVED";

// Util
export const UTIL_DATA_WAS_REQUESTED = "UTIL_DATA_WAS_REQUESTED";
export const USER_PAYMENTS_WAS_REQUESTED = "USER_PAYMENTS_WAS_REQUESTED";
export const USER_PAYMENTS_RECEIVED = "USER_PAYMENTS_RECEIVED";
export const USER_PAYMENTS_HAS_ERROR = "USER_PAYMENTS_HAS_ERROR";

// Modality
export const SCHEDULED = 4;
export const CONVENTIONAL = 1;
